import React from 'react';

export function RichText({ text }) {
  if (!text) return null;
  const lines = text.split('\n');
  const renderInline = (str) => {
    const parts = str.split(/(\*\*[^*]+\*\*)/g);
    return parts.map((p, i) =>
      p.startsWith('**') && p.endsWith('**')
        ? <strong key={i} className="font-semibold text-slate-900 dark:text-slate-100">{p.slice(2, -2)}</strong>
        : <span key={i}>{p}</span>
    );
  };
  return (
    <div className="space-y-1.5 text-sm text-slate-700 dark:text-slate-300 leading-relaxed">
      {lines.map((line, idx) => {
        const t = line.trim();
        if (!t) return <div key={idx} className="h-1" />;
        if (t.startsWith('- ') || t.startsWith('* ')) {
          return (
            <div key={idx} className="flex gap-2 pl-1">
              <span className="text-amber-500 mt-0.5">•</span>
              <span>{renderInline(t.slice(2))}</span>
            </div>
          );
        }
        if (/^#{1,6}\s/.test(t)) {
          return <h4 key={idx} className="font-bold text-slate-900 dark:text-slate-100 mt-2">{renderInline(t.replace(/^#{1,6}\s/, ''))}</h4>;
        }
        return <p key={idx}>{renderInline(t)}</p>;
      })}
    </div>
  );
}

export function LinkGroup({ icon: Icon, title, links }) {
  const labels = {
    booking_com: 'Booking.com', google_hotels: 'Google Hotels', agoda: 'Agoda',
    google_flights: 'Google Flights', skyscanner: 'Skyscanner', kayak: 'Kayak',
    airport_transfer_search: 'Airport Transfer',
  };
  return (
    <div className="rounded-lg border border-slate-200 dark:border-slate-700 p-3">
      <div className="flex items-center gap-2 mb-2">
        <Icon className="w-4 h-4 text-amber-600" />
        <span className="text-xs font-semibold text-slate-900 dark:text-slate-100">{title}</span>
      </div>
      <div className="flex flex-wrap gap-2">
        {Object.entries(links || {}).map(([k, url]) => (
          <a key={k} href={url} target="_blank" rel="noopener noreferrer"
             className="text-xs px-2.5 py-1 rounded-md bg-amber-50 dark:bg-amber-900/20 text-amber-700 dark:text-amber-300 hover:bg-amber-100 dark:hover:bg-amber-900/40 transition-colors">
            {labels[k] || k}
          </a>
        ))}
      </div>
    </div>
  );
}
